import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-select-search',
	templateUrl: './select-search.component.html',
	styleUrls: ['./select-search.component.scss'],
})
export class SelectSearchComponent implements OnInit {
	@Input() values;
	@Output() onSelected: EventEmitter<number> = new EventEmitter<number>();

	selected: any;
	@Input() startValue;
	@Input() fieldValue = 'id';
	@Input() placeholder = 'Select option';
	@Input() disabled = false;
	@Input() multiple = false;
	@Input() closeOnSelect = true;
	@Input() searchable = true;

	constructor() {
	}

	ngOnInit(): void {

	}

	ngDoCheck(): void {
		if(this.startValue) {
			this.getSelected();
		}
	}

	customSearchFn(term: string, item) {
		item.name = item.name.replace(',', '');
		term = term.toLocaleLowerCase();
		return item.name.toLocaleLowerCase().indexOf(term) > -1;
	}

	onChange() {
		if (this.selected) {
			this.onSelected.emit(this.selected);
		} else {
			this.onSelected.emit(0);
		}
	}

	getSelected() {
		if(this.values && this.values.length > 0) {
			this.selected = this.values.find(item => item[this.fieldValue] == this.startValue);
		}
	}
}
